
  <div [ngClass]="isDesktop ? 'desktop': 'mobile'" class="dialog-wrapper">
    <div class="dialog-container">
      <div class="title" >{{pageTitle}}:</div>
        <ng-container *ngIf="isFirstDepositBonusLottery">
            <div class="boosted-dialog" fxLayoutAlign="space-between center" fxLayout="row">
                <div class="teser-image"></div>
                <div>
                  <div class="text">{{teaser?.msg}}</div>
                  <div class="teaser-text">
                    <span i18n>Your bonus offer is{{countDown ? 'valid for' : ''}}:</span><span *ngIf="countDown" class="counter"> {{countDown?.minutes}}:{{countDown?.seconds}}m</span>
                  </div>
                </div>

                <div class="select-icon" (click)="openAdditionalBoostBonusTerms()" fxLayoutAlign="center center">
                    <img src="{{licenceService.getKey('icon-info-dark')}}" alt="info" />
                </div>
            </div>
            <div class="other-bonus-text" fxLayoutAlign="center center" fxLayout="row">
                <img src="assets/icons/icon-plus.svg" alt="info" />
                <div class="other-bonus-label" i18n>Add another available offer:</div>
            </div>
        </ng-container>
        <div class="bonus-list">
            <ng-container *ngFor="let item of bonusList; let last = last;let first=first; let index=index">
                <div class="bonus" [class.bonus-img-list]="item.isPrizeEngineEligiblePlayers" [ngClass]="{'selected': item?.externalId === selectedBonusInfo?.externalId}"  fxLayoutAlign="space-between center" fxLayout="row">
                    <!-- <div class="image"><img [src]="item.thumbnail?.url" /></div> -->
                    <!-- <span fxFlex></span> -->
                    <div fxLayoutAlign="start center" fxLayoutGap="12px" style="width: 100%;" (click)="selectBonus(item)" class="bonus-list-content">
                        <div fxLayoutAlign="center center" class="bonus-check">
                            <div *ngIf="!item.notForSelectedPayment" class="circle" [ngClass]="{'selected': item?.externalId === selectedBonusInfo?.externalId}">
                                <div *ngIf="item.externalId === selectedBonusInfo.externalId" class="inner-circle">
                                </div>
                            </div>
                        </div>
                        <div *ngIf="item.isPrizeEngineEligiblePlayers" class="bonus-img">
                            <img src="{{licenceService.getKey('compaign-switch')}}">
                        </div>
                        <div fxLayoutAlign="center center" class="bonus-txt">
                            <div class="info">
                                <div class="name">{{item.displayName}}</div>
                                <div *ngIf="!item.notForSelectedPayment" class="description">{{item.teaserText}}</div>
                                <div *ngIf="item.notForSelectedPayment" class="description not-available" i18n>This bonus is not available for selected payment method.</div>
                            </div>
                        </div>
                    </div>

                    <!-- <button round-button color="warn" filled="empty" fxFlex="27" *ngIf="!first" class="terms" (click)="openTermsDialog(item)" i18n>read terms</button> -->
                    <img *ngIf="first" style="width: 36px" (click)="selectBonus(item)" src="{{licenceService.getKey('icon-none')}}" alt="info" />
                    <div class="bonus-info-icon">
                        <img (click)="openTermsDialog(item)" *ngIf="item.isPrizeEngineEligiblePlayers;else colorInfo" src="{{licenceService.getKey('icon-deposit-compaign-info')}}" alt="info">
                    </div>
                    <ng-template #colorInfo>
                        <img *ngIf="!first" (click)="openTermsDialog(item, true)" style="width: 36px" src="{{item?.externalId === selectedBonusInfo?.externalId ? licenceService.getKey('icon-deposit-compaign-info-selected') : licenceService.getKey('icon-info-dark')}}" alt="info" />
                    </ng-template>
                </div>
            </ng-container>
        </div>
    </div>
  </div>
